import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'

import Markup from '../../markup';
import Icon from '../../markup/Global/Icon';
import {CalendarIcon, CalendarIconDark} from '../../const/icons';
import BuilderContext from '../../builder/hooks/context';
import {device} from "../../const/device";

type InfoType = {
  changeInfoWindow:(state:boolean) => void
}

function Info({changeInfoWindow}:InfoType) {
  const history = useHistory();
  const { builder } = useContext(BuilderContext);
  const tabletS = useMediaQuery({ query: `(${device.tabletS})` });
  const tablet = useMediaQuery({ query: `(${device.tablet})` });

  return (
    <>
      <Markup.Screen.Info.Header>
          {tablet || tabletS ? <Markup.Screen.Info.TitleContainer themeColor={'white'}>
              {builder?.manifest?.shipmentInfo?.title}
          </Markup.Screen.Info.TitleContainer> :
          <Markup.Screen.Info.TitleContainer themeColor={builder.membersData.colorTheme}>
          {builder?.manifest?.shipmentInfo?.title}
          </Markup.Screen.Info.TitleContainer>}

        <Markup.Screen.Info.IconContainer>
          <Markup.Global.Button.ButtonIconClose onClick={() => changeInfoWindow(false)} />
        </Markup.Screen.Info.IconContainer>
       
      
      </Markup.Screen.Info.Header>

      <Markup.Screen.Info.Block dangerouslySetInnerHTML={{__html:builder?.manifest?.shipmentInfo?.description}} themeColor={builder.membersData.colorTheme}>
       
      </Markup.Screen.Info.Block>

      <Markup.Screen.Info.Block themeColor={builder.membersData.colorTheme}>
          {tablet || tabletS ? <Markup.Screen.Info.BlockTitle children='Shipping' themeColor={'white'}/> :
              <Markup.Screen.Info.BlockTitle children='Shipping' themeColor={builder.membersData.colorTheme}/>}
        <div dangerouslySetInnerHTML={{__html:builder?.manifest?.shipmentInfo?.shipping}}></div>
      </Markup.Screen.Info.Block>

      <Markup.Screen.Info.Block themeColor={builder.membersData.colorTheme}>
          {tablet || tabletS ? <Markup.Screen.Info.BlockTitle themeColor={'white'}>Production time</Markup.Screen.Info.BlockTitle>: <Markup.Screen.Info.BlockTitle themeColor={builder.membersData.colorTheme}>Production time</Markup.Screen.Info.BlockTitle>}
          {tablet || tabletS ? <Icon icon={CalendarIcon} /> : <Icon icon={builder.membersData.colorTheme == "black"?CalendarIconDark:CalendarIcon} />}
          {builder?.manifest?.shipmentInfo?.production}
      </Markup.Screen.Info.Block>
    </>
  );
};

export default React.memo(Info);
